import React from "react";

const System = React.lazy(() => import('../../views/System/Page_Index'));

const quantri = [
    { path: "/system", exact: true, name: "system", component: System },
];

export default quantri;